import { gql } from '@common/hooks';

export const WorksMembershipRolesQuery = gql`
  query WorksMembershipRoles {
    worksMembershipRoles {
      text
      value
    }
  }
`;

export type WorksMembershipRolesResponse = {
  worksMembershipRoles: WorksMembershipRole[];
};

type WorksMembershipRole = {
  text: string;
  value: string;
};
